/* B2B Invoice Cart – v6.5
   - Solo blocco JSON con prefisso [FATTURA]:  [FATTURA] {"richiesta":"si",...}
   - Preserva SEMPRE il testo del cliente nella Nota
   - Mai /cart/change.js (non tocca i line items)
   - 1 POST leggera sui radio; salvataggio finale {attributes, note} via sendBeacon/keepalive
*/
(() => {
  if (window.B2BInvoiceCart_V65) return;
  window.B2BInvoiceCart_V65 = { mountAll, __ver: '6.5' };

  const SEL = {
    root: '[data-b2b-root]',
    content: '[data-b2b-section="content"]',
    priv: '[data-b2b-private]',
    biz:  '[data-b2b-biz]',
    radioWant: 'input[name="attributes[fattura_richiesta]"]',
    radioType: 'input[name="attributes[fattura_tipo]"]',
    cf1: '#b2b-cf', cf2: '#b2b-cf2', ragsoc: '#b2b-ragsoc', piva: '#b2b-piva', sdi: '#b2b-sdi', pec: '#b2b-pec',
    // tutte le varianti della textarea "Nota ordine"
    noteTA: 'textarea[name="note"], #cart-note, .cart__summary-note textarea, #Cart-Note textarea',
    cartForm: 'form[action*="/cart"]',
    checkoutBtn: 'button[name="checkout"], [data-checkout], a[href*="/checkout"]'
  };

  const qs  = (r,s)=>r.querySelector(s);
  const want = (r)=> !!qs(r, `${SEL.radioWant}[value="si"]:checked`);
  const type = (r)=> (r.querySelector(`${SEL.radioType}:checked`)?.value) || 'azienda';

  (document.readyState === 'loading') ? document.addEventListener('DOMContentLoaded', init) : init();
  function init(){
    mountAll();
    new MutationObserver(()=>mountAll()).observe(document.body,{childList:true,subtree:true});

    document.addEventListener('change', onRadio, true);
    document.addEventListener('click',  onRadio, true);
    document.addEventListener('input',  onInput, true);

    document.addEventListener('click',  onCheckoutClick, true);
    document.addEventListener('submit', onFormSubmit,  true);
    window.addEventListener('pagehide', saveFinalSafe, { capture:true });
  }

  function mountAll(){ document.querySelectorAll(`${SEL.root}:not([data-b2b-ready="1"])`).forEach(mount); }
  function mount(root){ root.setAttribute('data-b2b-ready','1'); applyUI(root); switchNames(root); }

  /* ---------- UI & naming ---------- */
  function onRadio(e){
    const t = e.target;
    if (!t || t.tagName!=='INPUT') return;
    if (!t.matches(SEL.radioWant) && !t.matches(SEL.radioType)) return;
    const root = t.closest(SEL.root); if (!root) return;
    requestAnimationFrame(()=>{ applyUI(root); switchNames(root); });
    saveToggles(root); // 1 POST leggera: mantiene lo stato dopo “Applica sconto”
  }
  function onInput(e){
    const t=e.target; if(!t || t.tagName!=='INPUT') return;
    const root=t.closest(SEL.root); if(!root) return;
    switchNames(root);
  }

  function applyUI(root){
    const opened = want(root), t = type(root);
    qs(root, SEL.content)?.toggleAttribute('hidden', !opened);
    qs(root, SEL.priv )?.toggleAttribute('hidden', !(opened && t==='privato'));
    qs(root, SEL.biz  )?.toggleAttribute('hidden', !(opened && t!=='privato'));
  }

  function switchNames(root){
    const opened = want(root), priv = (type(root)==='privato');
    const set = (sel, name, disabled) => { const el=qs(root, sel); if(!el) return; name ? el.setAttribute('name',name) : el.removeAttribute('name'); el.disabled=!!disabled; };
    if (!opened) {
      [SEL.cf1,SEL.cf2,SEL.ragsoc,SEL.piva,SEL.sdi,SEL.pec].forEach(s=>set(s,null,true));
      root.querySelectorAll(SEL.radioWant).forEach(r=> r.name='attributes[fattura_richiesta]');
      root.querySelectorAll(SEL.radioType).forEach(r=> r.name='attributes[fattura_tipo]');
      return;
    }
    if (priv) {
      set(SEL.cf1,'attributes[codice_fiscale]',false);
      set(SEL.cf2,null,true); set(SEL.ragsoc,null,true); set(SEL.piva,null,true); set(SEL.sdi,null,true); set(SEL.pec,null,true);
    } else {
      set(SEL.cf1,null,true);
      set(SEL.cf2,'attributes[codice_fiscale]',false);
      set(SEL.ragsoc,'attributes[ragsoc]',false);
      set(SEL.piva,'attributes[partita_iva]',false);
      set(SEL.sdi,'attributes[codice_sdi]',false);
      set(SEL.pec,'attributes[pec]',false);
    }
  }

  /* ---------- Raccolta valori ---------- */
  function gather(root){
    const opened = want(root), t = type(root), priv = (t==='privato');
    const val = (sel)=> (qs(root, sel)?.value || '').trim();
    const a = { fattura_richiesta: opened ? 'si':'no', fattura_tipo: t,
      ragsoc:'', codice_fiscale:'', partita_iva:'', codice_sdi:'', pec:'' };
    if (opened) {
      if (priv) a.codice_fiscale = val(SEL.cf1).toUpperCase();
      else {
        a.ragsoc = val(SEL.ragsoc);
        a.codice_fiscale = val(SEL.cf2).toUpperCase();
        a.partita_iva = val(SEL.piva).toUpperCase();
        a.codice_sdi = val(SEL.sdi).toUpperCase();
        a.pec = val(SEL.pec);
      }
    }
    return a;
  }

  /* ---------- Solo JSON con prefisso [FATTURA] ---------- */
  function buildJsonBlock(a){
    if (a.fattura_richiesta !== 'si') return '';
    return '[FATTURA] ' + JSON.stringify({
      richiesta: a.fattura_richiesta || '',
      tipo: a.fattura_tipo || '',
      ragsoc: a.ragsoc || '',
      codice_fiscale: a.codice_fiscale || '',
      partita_iva: a.partita_iva || '',
      codice_sdi: a.codice_sdi || '',
      pec: a.pec || ''
    });
  }

  // Rimuove SOLO i nostri blocchi precedenti, preservando il testo cliente:
  //  - vecchio [FATTURA_JSON] {…}
  //  - nuovo [FATTURA] {…}
  //  - eventuale vecchio [FATTURA] testuale su una sola riga
  function stripOurBlocks(note){
    if (!note) return '';
    note = note.replace(/\s*\[FATTURA_JSON]\s\{[\s\S]*?\}\s*/g, ''); // legacy
    note = note.replace(/\s*\[FATTURA]\s\{[\s\S]*?\}\s*/g, '');     // nuovo JSON
    note = note.replace(/(^|\n)\s*\[FATTURA][^\n]*\n?/g, '$1');     // legacy testuale
    return note.trim();
  }

  function writeNoteIntoForm(form, root){
    const ta = form.querySelector(SEL.noteTA);
    let userNote = ta && typeof ta.value === 'string' ? ta.value : '';
    userNote = stripOurBlocks(userNote); // preserva SOLO testo cliente

    const a = gather(root);
    const jsonBlock = buildJsonBlock(a);

    let finalNote = userNote;
    if (jsonBlock) finalNote += (finalNote ? '\n\n' : '') + jsonBlock;

    if (ta){ ta.name='note'; ta.value = finalNote; }
    return { attrs: a, note: finalNote };
  }

  /* ---------- POST helper ---------- */
  let lastKey='';
  function saveToggles(root){
    const payload = { fattura_richiesta: want(root) ? 'si' : 'no', fattura_tipo: type(root) };
    const key = JSON.stringify(payload); if (key === lastKey) return; lastKey = key;
    fetch('/cart/update.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ attributes: payload }),
      keepalive: true
    }).catch(()=>{});
  }

  let lastFinal='';
  function finalSave(attrs, note){
    const key = JSON.stringify({attrs, note}); if (key === lastFinal) return; lastFinal = key;
    const blob = new Blob([JSON.stringify({ attributes: attrs, note })], { type:'application/json' });
    if (navigator.sendBeacon) { navigator.sendBeacon('/cart/update.js', blob); return; }
    fetch('/cart/update.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: blob, keepalive:true }).catch(()=>{});
  }

  /* ---------- Hook submit / click / pagehide ---------- */
  function onFormSubmit(e){
    const form = e.target; if (!(form instanceof HTMLFormElement) || !form.matches(SEL.cartForm)) return;
    const root = form.querySelector(SEL.root) || document.querySelector(SEL.root); if (!root) return;
    applyUI(root); switchNames(root);
    const { attrs, note } = writeNoteIntoForm(form, root);
    finalSave(attrs, note);  // non blocca il submit
  }

  function onCheckoutClick(e){
    const btn = e.target.closest(SEL.checkoutBtn); if (!btn) return;
    const root = btn.closest(SEL.root) || document.querySelector(SEL.root); if (!root) return;
    const form = root.closest('form') || document.querySelector(SEL.cartForm);
    if (form) {
      const { attrs, note } = writeNoteIntoForm(form, root);
      finalSave(attrs, note);
    } else {
      const a = gather(root);
      const json = buildJsonBlock(a);
      finalSave(a, json || '');
    }
  }

  function saveFinalSafe(){
    const root = document.querySelector(SEL.root); if (!root) return;
    const form = root.closest('form') || document.querySelector(SEL.cartForm);
    if (form) {
      const { attrs, note } = writeNoteIntoForm(form, root);
      finalSave(attrs, note);
    } else {
      const a = gather(root);
      const json = buildJsonBlock(a);
      finalSave(a, json || '');
    }
  }
})();
